<template>
  <v-dialog
    v-model="dialog"
    width="660"
    persistent
  >
    <v-toolbar
      dense
      light
      class="grey lighten-2"
    >
      <v-toolbar-title class="text-body-1 font-weight-bold">
        {{ $t('m.datePicker') }}
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        icon
        color=""
        @click="handleCancel"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider />

    <v-card
      tile
      flat
      class="py-3"
    >
      <v-card-text class="pa-2">
        <v-row
          dense
          justify="center"
        >
          <v-col class="text-center">
            <v-date-picker
              small
              dense
              v-model="picker"
            />
          </v-col>
          <v-col class="text-center">
            <v-time-picker
              v-model="timePicker"
              format="24hr"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          color="blue darken-1"
          text
          @click="handleCancel"
        >
          {{ $t('m.cancel') }}
        </v-btn>
        <v-btn
          small
          dark
          color="blue darken-1"
          @click="handleSubmit"
        >
          {{ $t('m.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'

export default {
  name: 'DateAndTimeDlg',
  components: { },
  props: [
    'visible', 'myPicker', 'myTimePicker'
  ],
  data () {
    return {
      dialog: false,
      picker: null,
      timePicker: null,
      portAddBtnDisabled: true
    }
  },
  created () {
  },
  computed: {
    ...mapState({
      isRotating: state => state.estimating.isRotating,
      isGettedDistance: state => state.estimating.isGettedDistance
    })
  },
  watch: {
    visible: function (val) {
      this.picker = this.myPicker
      this.timePicker = this.myTimePicker
      this.dialog = val
    }

  },
  methods: {
    handleAddWatcher () {
    },

    handleSubmit () {
      this.$emit('save', {
        myArrivedDate: this.picker,
        myArrivedTime: this.timePicker
      })
    },

    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
